module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (68).3620c281.jpg";